var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('Fullcalendar',{attrs:{"header":{
      left: 'title',
      right: 'prev next'
    },"plugins":_vm.calendarPlugins,"events":_vm.events,"locale":"pt-br"},on:{"eventClick":_vm.showEvent,"select":_vm.handleSelect}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61bc897c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/dweller/profile/me/components/bookings/booking.vue
// module id = 7HsA
// module chunks = 110